import { Text } from "@virkesborsen/ui-component-library";

const howItWorksItems = [
  {
    title: "Logga in eller skapa digital skogsbruksplan",
    description:
      "Kom igång enkelt med din kostnadsfria, digitala skogsbruksplan på Treebula och välj din fastighet som du vill se prisförslag för.",
  },
  {
    title: "Se prisförslag på din fastighet",
    description:
      "Klicka på ‘Beställ drönarflygning’ ovanför och välj det alternativ som du är intresserad av. Ortofoto är förvalt som standard, men du kan enkelt lägga till skadeinventering för granbarkborre, eller ett kombinerat paket med skadeinventering för granbarkborre och toppbrott.",
  },
  {
    title: "Flygningen genomförs",
    description:
      "Efter slutförd beställning skickas en drönarpilot till området som fotograferar din skog med drönare. Piloten tar kontakt med dig vid behov, om det exempelvis finns vägbommar på området.",
  },
  {
    title: "Du får resultatet i din skogsbruksplan",
    description:
      "När bilderna är bearbetade och klara laddas de upp till din digitala skogsbruksplan, redo att användas direkt i ditt arbete med planering, inventering eller åtgärder.",
  },
];

export default function DroneHowTo() {
  return (
    <div className="h-full w-full bg-sandstone-dark">
      <div className="max-w-[1320px] mx-auto flex flex-col">
        <section className="flex flex-col gap-12 p-4 lg:p-16">
          <div className="flex flex-col gap-4">
            <Text variant="overlineLargeRegular">Hur fungerar det</Text>
            <Text variant="sectionHeaderMedium" className="">
              Så enkelt kommer du igång
            </Text>
          </div>
          <div className="flex flex-col gap-8 lg:flex-row">
            {howItWorksItems.map((item, index) => (
              <div className="flex flex-col flex-1">
                <Text
                  variant="subheaderMediumMedium"
                  className="text-pebble-500 p-4 rounded-bl-xl bg-stone-100 flex items-center justify-center mb-6"
                >
                  {index + 1}
                </Text>

                <Text variant="subheaderSmallMedium" className="mb-4">
                  {item.title}
                </Text>
                <Text
                  variant="bodyMediumBaseRegular"
                  className="text-pebble-500"
                >
                  {item.description}
                </Text>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
